import React, { Component } from 'react';
import { Accordion } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { get } from 'lodash';


import ChecklistSection from './checklist_section';

export default class Checklist extends Component {
  static propTypes = {
    projectTypeLabel: PropTypes.string.isRequired,
    sections: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      listingType: PropTypes.string.isRequired,
      projectStatus: PropTypes.string.isRequired,
      relation: PropTypes.string
    })).isRequired,
    showChecklistItemModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  };

  state = {
    activeKey: null
  }

  handleSelect = (eventKey) => {
    this.setState((prevState) => {
      return { activeKey: prevState.activeKey === eventKey ? null : eventKey };
    });
  }

  renderSection = (section) => {
    return (
      <ChecklistSection
        key={`${section.listingType}-${section.projectStatus}`}
        listingType={section.listingType}
        projectStatus={section.projectStatus}
        projectTypeLabel={this.props.projectTypeLabel}
        relation={section.relation}
        showChecklistItemModal={this.props.showChecklistItemModal}
        statusLabel={section.label}
      />
    );
  }

  render() {
    return (
      <Accordion activeKey={this.state.activeKey} className="mb-4" onSelect={this.handleSelect}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="d-flex align-items-center justify-content-between w-100">
              <p className="mb-0 flex-grow-1 fs-large fw-semibold">
                {this.props.title}
              </p>
            </div>
          </Accordion.Header>
          <Accordion.Body className="bg-white p-4">
            {this.props.sections.map(this.renderSection)}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
}
